import { render, staticRenderFns } from "./EModalTransferirMatricula.vue?vue&type=template&id=79ec299e&scoped=true"
import script from "./EModalTransferirMatricula.vue?vue&type=script&lang=js"
export * from "./EModalTransferirMatricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ec299e",
  null
  
)

export default component.exports